import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import ChatInput from './ChatInput';
import MessageBubble from './MessageBubble';
const ChatPanel = ({ onClose, open }) => {
    const messages = useSelector((state) => state['features/chat'].messages);
    const localId = useSelector((state) => state['features/base/participants'].local?.id);
    const messagesEndRef = useRef(null);
    useEffect(() => {
        if (open) {
            messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [messages.length, open]);
    return (React.createElement("div", { "aria-label": 'Chat', role: 'dialog', style: {
            background: 'rgba(17,3,7,0.96)',
            backdropFilter: 'blur(12px)',
            borderRight: '1px solid rgba(215,175,185,0.10)',
            bottom: 0,
            display: 'flex',
            flexDirection: 'column',
            height: '100dvh',
            left: 0,
            position: 'fixed',
            top: 0,
            transform: open ? 'translateX(0)' : 'translateX(-100%)',
            transition: 'transform 280ms cubic-bezier(0.4, 0, 0.2, 1)',
            width: '320px',
            zIndex: 10000
        } },
        React.createElement("div", { style: {
                alignItems: 'center',
                borderBottom: '1px solid rgba(215,175,185,0.12)',
                display: 'flex',
                flexShrink: 0,
                justifyContent: 'space-between',
                padding: '18px 16px'
            } },
            React.createElement("span", { style: {
                    color: '#EFE5DC',
                    fontSize: '15px',
                    fontWeight: 600,
                    letterSpacing: '0.2px'
                } }, "Chat"),
            React.createElement("button", { "aria-label": 'Fermer le chat', onClick: onClose, style: {
                    alignItems: 'center',
                    background: 'rgba(255,255,255,0.06)',
                    border: 'none',
                    borderRadius: '50%',
                    color: 'rgba(239,229,220,0.7)',
                    cursor: 'pointer',
                    display: 'flex',
                    height: '32px',
                    justifyContent: 'center',
                    transition: 'background 0.15s',
                    width: '32px'
                } },
                React.createElement("svg", { fill: 'none', height: '16', viewBox: '0 0 24 24', width: '16', xmlns: 'http://www.w3.org/2000/svg' },
                    React.createElement("path", { d: 'M18 6L6 18M6 6L18 18', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' })))),
        React.createElement("div", { style: {
                flex: 1,
                overflowY: 'auto',
                padding: '12px 0',
                scrollbarWidth: 'none'
            } },
            messages.length === 0 && (React.createElement("p", { style: {
                    color: 'rgba(239,229,220,0.35)',
                    fontSize: '13px',
                    marginTop: '40px',
                    textAlign: 'center'
                } }, "Aucun message pour l'instant")),
            messages.map((msg) => (React.createElement(MessageBubble, { displayName: msg.displayName || 'Participant', isLocal: msg.id === localId, key: `${msg.id}-${msg.timestamp}`, message: msg.message, timestamp: msg.timestamp }))),
            React.createElement("div", { ref: messagesEndRef })),
        React.createElement(ChatInput, null)));
};
export default ChatPanel;
